// Mirrors PageAccess::modeOf (PHP): absent = public, unknown = restricted (fail closed).
export const PAGE_ACCESS_OPTION = "page-access";
export const PAGE_ACCESS_PUBLIC = "public";
export const PAGE_ACCESS_LOGGED_IN = "logged_in";
export const PAGE_ACCESS_RESTRICTED = "restricted";
export const PAGE_ACCESS_MODES = [PAGE_ACCESS_PUBLIC, PAGE_ACCESS_LOGGED_IN, PAGE_ACCESS_RESTRICTED];

export function pageAccessModeOf(rootOptions) {
  let options = rootOptions;
  if (typeof options === "string") {
    try {
      options = JSON.parse(options);
    } catch (e) {
      return PAGE_ACCESS_PUBLIC;
    }
  }
  let value = options?.[PAGE_ACCESS_OPTION];
  if (value === undefined || value === null) {
    return PAGE_ACCESS_PUBLIC;
  }
  if (typeof value === "string") {
    try {
      value = JSON.parse(value);
    } catch (e) {
      return PAGE_ACCESS_RESTRICTED;
    }
  }
  return PAGE_ACCESS_MODES.includes(value?.mode) ? value.mode : PAGE_ACCESS_RESTRICTED;
}
